import styles from './FJSourcePreviewItemBtu.module.less';
import { memo, useState } from 'react';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip';
import ComparisonIcon from '../../../assets/svg/comparison.svg?react';
import DeleteIcon from '../../../assets/svg/delete.svg?react';
import FJLoading from '../../../common/components/FJLoading/FJLoading';
import DownloadIcon from '../../../assets/svg/download.svg?react';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import FJConfig from '../../../config/FJConfig';
import FJAppConstant from '../../../constants/FJAppConstant';
import PropTypes from 'prop-types';
import FJMessageStore from '../../../store/FJMessageStore';
import FJConstant from '../../../constants/FJConstant';

const FJSourcePreviewItemBtu = memo(props => {
    const {
        selected = false,
        propsIsHover = false,

        sourceLoadStatus,
        sourceOriginLoadStatus,
        isComparison,
        onReloadOrigin,

        isShowSelected = false,
        hideCompare = true,
        hideDelete = false,
        hideDownload = false,
        hideEdit = true,
        hideSelect = false,

        onSelected,
        onDelete,
        onDownload,
        onEdit,
        setIsComparison,
    } = props;
    const isShowCheck = !hideSelect && status !== 'progress';

    const [stateIsDownloadLoading, setStateIsDownloadLoading] = useState(false);
    const [stateIsEditLoading, setStateIsEditLoading] = useState(false);

    const _forbidEvent = e => {
        e.stopPropagation();
    };

    const _onSelected = (bool, e) => {
        e.stopPropagation();
        onSelected && onSelected(bool, e);
    };

    const _compareMouseDown = () => {
        if (sourceLoadStatus === FJConstant.ERROR || sourceOriginLoadStatus === FJConstant.ERROR) {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-preview-please-try-again'), 'error');
            onReloadOrigin && onReloadOrigin();
            return;
        }
        if (isComparison || sourceOriginLoadStatus !== FJConstant.SUCCESS) return;
        setIsComparison(true);
    };

    const _onDelete = e => {
        e.stopPropagation();
        onDelete && onDelete();
    };

    const _onDownload = e => {
        e.stopPropagation();
        if (stateIsDownloadLoading) {
            return;
        }
        setStateIsDownloadLoading(true);
        onDownload && onDownload(() => setStateIsDownloadLoading(false));
    };

    const _onEdit = e => {
        e.stopPropagation();
        setStateIsEditLoading(true);
        onEdit &&
            onEdit(() => {
                setStateIsEditLoading(false);
            });
    };

    return (
        <>
            {isShowCheck && (
                <FJCheckBox
                    selected={selected}
                    dataChange={_onSelected}
                    className={classNames(styles.checkbox, {
                        [styles.checkbox_show]: selected || propsIsHover,
                    })}
                />
            )}
            {!isShowSelected && (
                <div
                    className={classNames(styles.header_right, {
                        [styles.header_right_show]: propsIsHover || selected,
                    })}
                >
                    {!hideCompare && (
                        <FJToolTip title={'compare'}>
                            <div
                                className={styles.hover_icon_box}
                                onMouseDown={_compareMouseDown}
                                onClick={_forbidEvent}
                            >
                                <ComparisonIcon />
                            </div>
                        </FJToolTip>
                    )}
                    {!hideDelete && (
                        <FJToolTip title={'delete'}>
                            <div className={styles.hover_icon_box} onClick={_onDelete}>
                                <DeleteIcon className={styles.delete_icon} />
                            </div>
                        </FJToolTip>
                    )}
                    {!hideDownload && (
                        <FJToolTip title={'download'}>
                            <div className={styles.hover_icon_box} onClick={_onDownload}>
                                {stateIsDownloadLoading ? (
                                    <FJLoading style={{ width: 16, height: 16 }} />
                                ) : (
                                    <DownloadIcon />
                                )}
                            </div>
                        </FJToolTip>
                    )}
                </div>
            )}
            {!hideEdit && (
                <FJIconButton
                    className={classNames(styles.use_this, {
                        [styles.use_this_loading]: stateIsEditLoading,
                        [styles.photo_remove_bg_edit]:
                            FJConfig.appType === FJAppConstant.PHOTO_REMOVE_BG ||
                            FJConfig.appType === FJAppConstant.VIDEO_REMOVE_BG,
                        [styles.use_this_show]: propsIsHover && !isShowSelected,
                    })}
                    textClassName={styles.use_this_text}
                    text={FJLocalStore._('edit')}
                    onClick={_onEdit}
                    isLoading={stateIsEditLoading}
                />
            )}
        </>
    );
});

FJSourcePreviewItemBtu.displayName = 'FJSourcePreviewItemBtu';

FJSourcePreviewItemBtu.propTypes = {
    isShowSelected: PropTypes.bool,
    hideCompare: PropTypes.bool,
    hideDelete: PropTypes.bool,
    hideDownload: PropTypes.bool,
    hideEdit: PropTypes.bool,
    hideSelect: PropTypes.bool,
    selected: PropTypes.bool,
    onSelected: PropTypes.func,
    onDelete: PropTypes.func,
    onDownload: PropTypes.func,
    onEdit: PropTypes.func,
    onForbidEvent: PropTypes.func,
    propsIsHover: PropTypes.bool,
    isComparison: PropTypes.bool,
    setIsComparison: PropTypes.func,
    sourceLoadStatus: PropTypes.string,
    sourceOriginLoadStatus: PropTypes.string,
    onReloadOrigin: PropTypes.func,
};
export default FJSourcePreviewItemBtu;
